import useColorMode from '../../hooks/useColorMode';
import SvgIcon from '../../components/SvgIcon/SvgIcon';

/**
 * 🌗 Switch para cambiar entre modo claro y oscuro
 * Usa los íconos globales <SunIcon /> y <MoonIcon /> del sistema.
 */
const DarkModeSwitcher = () => {
  const [colorMode, setColorMode] = useColorMode();

  const handleToggle = () => {
    if (typeof setColorMode === 'function') {
      setColorMode(colorMode === 'light' ? 'dark' : 'light');
    }
  };

  return (
    <li>
      <label
        className={`relative m-0 block h-7.5 w-14 rounded-full transition-colors duration-300 ${
          colorMode === 'dark' ? 'bg-primary' : 'bg-stroke dark:bg-strokedark'
        }`}
      >
        {/* 🔘 Input invisible que controla el cambio */}
        <input
          type="checkbox"
          onChange={handleToggle}
          className="dur absolute top-0 z-50 m-0 h-full w-full cursor-pointer opacity-0"
        />

        {/* 🌞 / 🌙 Toggle circular */}
        <span
          className={`absolute top-1/2 left-[3px] flex h-6 w-6 -translate-y-1/2 translate-x-0 items-center justify-center rounded-full bg-white shadow-switcher duration-200 ease-linear ${
            colorMode === 'dark' && '!right-[3px] !translate-x-full'
          }`}
        >
          {/* ☀️ Icono de sol para modo claro */}
          <span className="dark:hidden">
            <SvgIcon name="sun" width={16} height={16} className="text-gray-500" />
          </span>

          {/* 🌙 Icono de luna para modo oscuro */}
          <span className="hidden dark:inline-block">
            <SvgIcon name="moon" width={16} height={16} className="text-gray-400" />
          </span>
        </span>
      </label>
    </li>
  );
};

export default DarkModeSwitcher;
